/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch";
};
export type SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch$data = SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch;
export type SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '7cfe10f30c66e545cdf77cad5ad59d88';
export default node;
